import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CheckOutService } from '../../services/checkout.service';
import { GetEndUserSalesTypeOut, GetEndUserAddressBookOutput } from '../../models/check-out.model';

@Component({
  selector: 'app-enduser-address',
  templateUrl: './enduser-address.component.html',
  styleUrls: ['./enduser-address.component.css']
})
export class EnduserAddressComponent implements OnInit {
  title = 'End User Information';
  loadContent: boolean = false;
  filterInput: string
  salesTypes: GetEndUserSalesTypeOut[];
  // selectedSalesType: string;
  endUserAddressBooks: GetEndUserAddressBookOutput[];
  endUserAddressBooksFilter: GetEndUserAddressBookOutput[];

  hasEmptyFilterResult: boolean = false;
  constructor(
    private router: Router,
    private checkOutService: CheckOutService,
    private activatedRoute: ActivatedRoute
  ) {
  }
  @ViewChild('entry', { read: ViewContainerRef }) entry: ViewContainerRef;

  ngOnInit() {
    $('.page-contents').animate({ scrollLeft: $('#levelOne').width() }, 400);

    this.getEndUserAddressSelectionView();

    this.activatedRoute.queryParamMap.subscribe(param => {
      const needRefresh = param.get('refresh');

      if (needRefresh) {
        this.getEndUserAddressSelectionView();
        this.filterInput = '';
      }
    });
  }

  getEndUserAddressSelectionView() {
    this.loadContent = false;
    this.checkOutService.GetEndUserAddressSelectionView("").subscribe((res: GetEndUserSalesTypeOut[]) => {
      this.salesTypes = res;

      // this.selectedSalesType = this.salesTypes[0].out_sales_type.split(' ')[0];
      this.checkOutService.EndUserAddressBook("").subscribe((result: GetEndUserAddressBookOutput[]) => {
        this.endUserAddressBooks = result;
        this.endUserAddressBooksFilter = this.endUserAddressBooks;
        this.endUserAddressBooksFilter.sort(function (a, b) {
          if (a.out_display_name < b.out_display_name) { return -1; }
          if (a.out_display_name > b.out_display_name) { return 1; }
          return 0;
        });
        this.loadContent = true;
      },
        (error: any) => {
          console.error(error);
        });
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  selectSalesType(salesType: string): void {
    this.endUserAddressBooks = [];
    this.endUserAddressBooksFilter = [];
    this.checkOutService.EndUserAddressBook(salesType).subscribe((result: GetEndUserAddressBookOutput[]) => {
      this.endUserAddressBooks = result;
      this.endUserAddressBooksFilter = this.endUserAddressBooks;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  searchEndUserAddressBook(): void {
    this.endUserAddressBooksFilter = this.endUserAddressBooks.filter(addressBook =>
      addressBook.out_display_name.toLowerCase().includes(this.filterInput.toLowerCase()) ||
      addressBook.out_company_name.toLowerCase().includes(this.filterInput.toLowerCase()) ||
      addressBook.out_email.toLowerCase().includes(this.filterInput.toLowerCase()) ||
      addressBook.out_mobile.toLowerCase().includes(this.filterInput.toLowerCase()) ||
      addressBook.out_phone.toLowerCase().includes(this.filterInput.toLowerCase()) ||
      addressBook.out_fax.toLowerCase().includes(this.filterInput.toLowerCase()) ||
      addressBook.out_address_1.toLowerCase().includes(this.filterInput.toLowerCase()) ||
      addressBook.out_address_2.toLowerCase().includes(this.filterInput.toLowerCase()) ||
      addressBook.out_address_3.toLowerCase().includes(this.filterInput.toLowerCase()) ||
      addressBook.out_address_4.toLowerCase().includes(this.filterInput.toLowerCase()) ||
      addressBook.out_address_5.toLowerCase().includes(this.filterInput.toLowerCase()) ||
      addressBook.out_suburb.toLowerCase().includes(this.filterInput.toLowerCase()) ||
      addressBook.out_state.toLowerCase().includes(this.filterInput.toLowerCase()) ||
      addressBook.out_country.includes(this.filterInput.toLowerCase()) ||
      addressBook.out_postcode.toLowerCase().includes(this.filterInput.toLowerCase())
    );
    if (this.endUserAddressBooksFilter.length === 0) {
      this.hasEmptyFilterResult = true;

    } else {
      this.hasEmptyFilterResult = false;
    }
  }

  editEndUserAddressBook(endUserAddressBook: GetEndUserAddressBookOutput): void {
    this.checkOutService.monitorGetEndUserAddressBook(endUserAddressBook);
    this.router.navigate(['enduseraddress/editenduseraddress'], { relativeTo: this.activatedRoute.parent });
  }

  addNewEndUser(): void {
    const addressBook: GetEndUserAddressBookOutput = this.endUserAddressBooks.length ? this.endUserAddressBooks[0] : {} as GetEndUserAddressBookOutput;
    this.checkOutService.monitorGetEndUserAddressBook(addressBook);
    // this.checkOutService.monitorGetEndUserAddressBook(this.endUserAddressBooks[0]);
    this.router.navigate(['enduseraddress/addenduser'], { relativeTo: this.activatedRoute.parent });
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    this.router.navigateByUrl('/myAccount');
  }
}